import { ApeironSsoCookieKey as o, ApeironSsoLoginType as y } from "../constants/apeironSso.js";
import { sessionCookieOptions as b, syncSessionCookie as j } from "../utils/sessionCookies.js";
import { LocalStorageKey as C } from "../../temp-lib/constants/storage.js";
import { WalletType as h, WAGMI_RECENT_CONNECTOR_ID as x } from "../../temp-lib/constants/web3.js";
import { useConfigContext as M } from "../../temp-lib/contexts/config/ConfigContext.js";
import { renewAccessToken as N } from "../../temp-lib/graphql/helper/refreshToken.js";
import { getRefreshToken as d, getAccessToken as L, cleanTokens as S, saveTokens as _, saveChainType as K, saveProvider as P, cleanChainType as O } from "../../temp-lib/util/authenication/index.js";
import { tokenExpired as l, sameTokenSession as I } from "../../temp-lib/util/authenication/token.js";
import { jwtDecode as G } from "jwt-decode";
import * as f from "ramda";
import { useState as H, useMemo as q, useEffect as z, useCallback as k } from "react";
import { useCookies as B } from "react-cookie";
const F = () => {
  const [m, g, t] = B(
    [
      o.AccessToken,
      o.Logout,
      o.LoginType,
      o.ChainType,
      o.WalletType
    ],
    { doNotParse: !0 }
  );
  return {
    cookies: m,
    setCookie: g,
    removeCookie: t
  };
}, to = () => {
  var v;
  const [m, g] = H(!1), { cookies: t, setCookie: c, removeCookie: s } = F(), { config: W } = M(), p = ((v = W.apollo) == null ? void 0 : v.domainLogin) || "", e = q(b, []), u = t[o.AccessToken], A = t[o.Logout];
  z(() => {
    let n = !1;
    return (async () => {
      if (A) {
        S(), O();
        return;
      }
      if (d()) {
        try {
          const r = await N(p);
          r && j(r);
        } catch {
        }
        return;
      }
      u && l(u, 0) && (s(o.AccessToken, e), s(o.LoginType, e));
    })().catch(() => {
    }).finally(() => {
      n || g(!0);
    }), () => {
      n = !0;
    };
  }, [
    u,
    A,
    p,
    s,
    e
  ]);
  const R = k(() => {
    const n = t[o.LoginType];
    if (n) return n;
    if (d() && !l(L(), 0)) {
      const i = localStorage.getItem(C.SsoLoginType);
      if (i && Object.values(y).includes(
        i
      ))
        return i;
    }
    return null;
  }, [t]), w = k(
    (n, i, r) => {
      localStorage.setItem(C.SsoLoginType, i), s(o.Logout, e), c(o.AccessToken, n, e), c(o.LoginType, i, e), i === y.Ronin && r && Object.values(h).includes(r) ? c(o.WalletType, r, e) : s(o.WalletType, e);
      const T = G(n), a = f.propOr(
        null,
        "loginNetwork",
        T
      );
      f.isNotNil(a) && c(o.ChainType, a, e);
    },
    [e, c, s]
  ), D = k(async () => {
    const n = t[o.AccessToken], i = t[o.ChainType];
    if (f.isNotNil(n) && f.isNotNil(i)) {
      d() && l(L(), 0) && await N(p);
      const r = L();
      if (I(r, n) || S(), l(n, 0) && r && !l(r, 0) && I(r, n))
        return;
      const T = t[o.LoginType];
      T && localStorage.setItem(C.SsoLoginType, T), _(n), K(i);
      const a = t[o.WalletType];
      t[o.LoginType] === y.Ronin && a && Object.values(h).includes(a) && (P(a), localStorage.removeItem(x));
    }
  }, [t, p]), E = k(() => {
    c(o.Logout, String(Date.now()), e), S(), O(), s(o.AccessToken, e), s(o.LoginType, e), s(o.ChainType, e), s(o.WalletType, e);
  }, [e, s, c]);
  return {
    inited: m,
    clearCookies: E,
    getLoginType: R,
    moveTokenToLocal: D,
    saveLoginDataToCookie: w
  };
};
export {
  to as default
};
//# sourceMappingURL=useApeironSsoCookieHandler.js.map
